// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".class-nav--classNav--CHgXhIjV {\n  background-color: #e2f4f8;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  height: 225px;\n  padding-bottom: 15px;\n  width: 240px;\n  z-index: 2;\n}\n.class-nav--classNav--CHgXhIjV .class-nav--chooseClass--xy39Xsxy {\n  margin: 20px 0 15px 19px;\n}\n.class-nav--classNav--CHgXhIjV .class-nav--itemSort--2dBFYH6F {\n  margin-left: 19px;\n}\n", ""]);
// Exports
exports.locals = {
	"classNav": "class-nav--classNav--CHgXhIjV",
	"chooseClass": "class-nav--chooseClass--xy39Xsxy",
	"itemSort": "class-nav--itemSort--2dBFYH6F"
};
module.exports = exports;
